// An emergency standing-height estimate, not physical floor calibration.
export const FALLBACK_EYE_HEIGHT = 1.65;

export function floorRecoveryOffset(height) {
  if (!Number.isFinite(height)) return null;
  return height < -0.25 || height > 3
    ? FALLBACK_EYE_HEIGHT - height
    : 0;
}

// Evaluate only on entry or a reference-space reset. Never counteract normal
// head motion, crouching, or teleportation by continuously normalizing height.
export function createFloorRecovery() {
  let pending = true;
  return {
    reset() { pending = true; },
    sample(pose) {
      if (!pending || !pose || pose.emulatedPosition) return null;
      const offset = floorRecoveryOffset(pose.transform?.position?.y);
      if (offset === null) return null;
      pending = false;
      return offset;
    },
  };
}
